// extracted by mini-css-extract-plugin
module.exports = {"westminsterTowerStory":"style_westminsterTowerStory__8KaXt"};